const en = {
    loc_leaderboard: 'leaderboard',
    loc_leaderboard_info: 'Earn <span>points</span>. The more points you have, the best <span>prizes</span> will be available for you',
    loc_see_discount: 'see discount',
    loc_turn_sound_off: 'turn sound off',
    loc_turn_sound_on: 'turn sound on',
    loc_discount: 'discount',
    loc_your_discounts: 'your disounts',
    loc_start_game: 'start game',
    loc_go_to_the_website: 'go to the website',
    loc_welcome: 'welcome',
    // loc_what_is_your_name: 'create a gaming name',
    loc_incorect_name: 'gaming name required',
    loc_map_screen: 'map screen',
    loc_go_back: 'go back',
    loc_tutorial: 'tutorial',
    loc_login_placeholder: 'name',
    loc_next_tip: 'next tip',
    loc_phone_oriental: 'Please, flip your phone for better experience.',
    loc_pixi_pause: 'PAUSE',
    loc_pixi_pts: 'PTS',
    loc_tiles_dropped: 'TILES DROPPED',
    loc_pixi_sec: 'sec',
    loc_pixi_min: 'min',
    loc_pixi_discount: 'Discount',
    loc_bg_release_tutorial_1: 'Gather three identical tiles in a row, swapping adjacent tiles',
    loc_bg_release_tutorial_2: 'Each tile in a row opens a place of background, clear the whole background to complete the level',
    loc_drop_product_tutorial: 'Move the SuperStay Matte Ink Liquid Lipstick by gathering tiles down',
    loc_fill_bar_tutorial: 'Collect tiles in rows to fill the progress bar and complete the level',
    loc_lose_popup: 'LEVEL % FAILED',
    loc_win_popup: 'LEVEL % COMPLETE',
    loc_tutorial_name_fillBar: 'fill the bar',
    loc_tutorial_name_background_release: 'background release',
    loc_tutorial_name_drop_product: 'drop product',
    loc_loading: 'LOADING',
    loc_play: 'play',
    loc_level: 'level',
    loc_done: 'DONE',
    loc_create_account: 'CREATE AN ACCOUNT',
    loc_please_log_in: 'PLEASE LOG IN OR',
    loc_try_again: 'TRY AGAIN',
    loc_you_win: 'YOU WIN!',
    loc_oops: 'OOPS!',
    loc_login_info: "IT LOOKS LIKE YOU'RE NOT LOGGED IN",
    loc_login: 'LOG IN',
    loc_hello: 'HELLO',
    loc_resume: 'RESUME',
    loc_press_to_shuffle: 'PRESS TO SHUFFLE',
    loc_no_moves: "THERE ARE NO MOVES",
    loc_comma: ',',
    // new text
    loc_super_stay: 'Super Stay<br>Match The Ink',
    loc_what_is_your_name: 'Create your nickname',
    loc_sign_up_title: 'SIGN UP & PLAY ALL DAY',
    loc_wecome_back: 'Wecome back to the<br>Super Stay Match The Ink Game',
    loc_sign_up_now: 'Sign up now to play & get a lipstick coupon!<br>*Offer available for new accounts only.',
    loc_get_started: 'get started',
    loc_play_as_guest: 'OR play as guest',
    loc_login_link: 'Already have an account? Login',
    loc_form_email: 'Email address*',
    loc_error_email: 'Email is required',
    loc_form_pass: 'Password*',
    loc_error_pass: 'Password is required.',
    loc_forgot_pass: 'Forgot Password',
    loc_form_first_name: 'First Name*',
    loc_error_first_name: 'First Name is required',
    loc_form_last_name: 'Last Name*',
    loc_error_last_name: 'Last Name is required',
    loc_form_day: 'Day*',
    loc_form_month: 'Month*',
    loc_form_year: 'Year*',
    loc_error_day: 'Day Required',
    loc_error_month: 'Month Required',
    loc_error_year: 'Year Required',
    loc_form_mandatory: '* Indicates mandatory field',
    loc_form_terms: 'Terms and Conditions',
    loc_form_privacy: 'Privacy Policy',
    loc_form_required: 'Required',
    loc_form_agree: 'I agree to the ',
    loc_form_agree_and: 'and ',
    loc_form_notified: 'YES! I want to be notified about exclusive content &amp; offers from Express, as well as the latest from Maybelline on products, tips, sweepstakes and more.',
    loc_form_st_comment: 'sign up is for US consumers. By registering, your information will be collected and used in the US subject to our US',
    loc_form_end_comment: "for this website, and you are verifying that you are 13 years of age or older. By signing up, I agree to receive emails from Maybelline and other L'Oréal brands and programs. Non-US consumers should visit the country website serving their region.",
};

export default en;